import { getUrlParameter } from '@/helpers/url'

export function isTesting () {
  return process.env.VUE_APP_ENV === 'testing'
}

export function isZavaEmail (email) {
  return email.match(/^e2e\+.*@(dred|zavamed).com$/gi)
}

export function isZavaBrand () {
  return process.env.VUE_APP_BRAND === 'zava'
}

export function isSuperdrugBrand () {
  return process.env.VUE_APP_BRAND === 'superdrug'
}

export function isAsdaBrand () {
  return process.env.VUE_APP_BRAND === 'asda'
}

export function isHBBrand () {
  const HAS_REDIRECT = getUrlParameter('redirect')
  let assessmentServiceId = ''
  if (HAS_REDIRECT && HAS_REDIRECT.indexOf('/assessment/') > 0) {
    let assessmentServiceUrl = HAS_REDIRECT.split('/assessment/')[1].match(/\d+/g)
    assessmentServiceId = assessmentServiceUrl[0]
  }
  return assessmentServiceId === '1002172'
}

export function thirdPartyBrand () {
  let thirdPartyBrand = false
  if (isSuperdrugBrand()) {
    thirdPartyBrand = 'sd'
  } else if (isHBBrand()) {
    thirdPartyBrand = 'hb'
  }
  return thirdPartyBrand
}
